module.exports = __webpack_public_path__ + "media/application/images/ui/email-logo-4b8934a04162bced102b161f5b4ded81.png";